import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Address } from '../../../core/models/address.model';
import { ButtonComponent } from '../button/button.component';
import { ModalDialogComponent } from '../modal-dialog/modal-dialog.component';
import { TranslatePipe } from '../../pipes/translate.pipe';

/**
 * Gate shown before creating or editing an interaction against an address
 * flagged do-not-contact — regardless of which outcome the rep ends up
 * picking. Replaces the old per-outcome override check that used to live
 * inside the interaction form's Save button (design doc §6.3 supersession —
 * see the Record Interaction redesign plan).
 */
@Component({
  selector: 'app-dnc-confirm-dialog',
  standalone: true,
  imports: [ButtonComponent, ModalDialogComponent, TranslatePipe],
  templateUrl: './dnc-confirm-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dnc-confirm-dialog.component.css',
})
export class DncConfirmDialogComponent {
  @Input() address: Address | null = null;
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();
}
